import { useState } from "react";
import { XIcon } from "@heroicons/react/outline";

const inputCls =
  "w-full bg-[#0d1424] border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-slate-600 focus:outline-none focus:ring-2 focus:ring-pink-500/40 focus:border-pink-500/30 transition";

const labelCls =
  "block text-xs font-medium uppercase tracking-widest text-slate-400 mb-1.5";

const OtherFeeModal = ({ onClose, onSave }) => {
  const [form, setForm] = useState({
    description: "",
    amount: "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    onSave(form);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4">
      <div className="w-full max-w-sm bg-slate-900 border border-white/10 rounded-2xl shadow-2xl">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <div>
            <h2 className="text-base font-semibold text-white">Add Other Fee</h2>
            <p className="text-xs text-slate-500 mt-0.5">Attach an extra charge to this booking</p>
          </div>
          <button
            onClick={onClose}
            className="text-slate-500 hover:text-white transition p-1 rounded-lg hover:bg-slate-800"
          >
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          <div>
            <label className={labelCls}>Fee Description</label>
            <input
              type="text"
              value={form.description}
              onChange={(e) => handleChange("description", e.target.value)}
              placeholder="e.g. Accommodation, Travel, Rider…"
              className={inputCls}
            />
          </div>

          <div>
            <label className={labelCls}>Amount</label>
            <input
              type="number"
              value={form.amount}
              onChange={(e) => handleChange("amount", e.target.value)}
              placeholder="0.00"
              min="0"
              step="0.01"
              className={inputCls}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-5 py-2 text-sm rounded-lg text-white font-medium bg-pink-600 hover:bg-pink-700 transition"
          >
            Add Fee
          </button>
        </div>

      </div>
    </div>
  );
};

export default OtherFeeModal;